/**
 * Created by Jaehyun on 2018-12-01.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Collapse, Navbar, NavbarBrand, NavItem, NavbarToggler, Nav } from 'reactstrap';
import cfg from '../config'

class Header extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.onCall = this.onCall.bind(this);

        this.state = {
            isOpen: false
            ,active : this.props.active
        };
    }

    toggle() {
        console.log('toggle')
        this.setState({
            isOpen: !this.state.isOpen
        });

        //if(id) this.setState({active : id});
    }

    onCall(e) {
        e.preventDefault();
        window.gtag('event', 'call - header', {
            'event_category' : 'Contact',
            'event_label' : cfg.phone
        });
        window.location.href = 'tel:'+cfg.phone
    }

    render(){

        let menus = this.props.menu.map((ele, idx)=>{

            {/*<UiCollapseItem key={ele.id} item={ele} activeId={this.state.activeId} onOpen={this.open} />*/}
            return (
                <NavItem key={ele.id} onClick={this.toggle}>
                    <Link to={this.props.menu[idx].link} className={"nav-link"}
                          id={'m-'+this.props.menu[idx].code}
                          data-isspyon={this.props.menu[idx].isScrollspy}>
                    {this.props.menu[idx].title}</Link>
                </NavItem>
            )
        });

        return (
            <header className="container-fluid fixed-top no-padding" id="top-head">
                    <nav className="no-padding navbar-light">
                        <div className="wrapper-content navbar justify-content-center">

                            {/*<div className={'navbar'}>*/}
                                <NavbarBrand href="/" className={'align-self-center'}>
                                    <p id={'logo-copy'} className={'transition'}>Your smart<br/> business card manager</p>
                                    <span id="logo">
                                        <img src="../static/img/keeper-b.png" alt="Keeper B logo"
                                             className=""/>
                                    </span>
                                    <p id={'logo-name'} className="transition">Keeper B</p>
                                </NavbarBrand>
                                {/*<NavbarToggler onClick={this.toggle} />*/}
                                <Collapse isOpen={this.state.isOpen} navbar id="nav-menu">
                                    <Nav className="nav ml-auto" navbar>
                                        {menus}
                                    </Nav>
                                </Collapse>
                            {/*</div>*/}
                        </div>
                    </nav>
            </header>
        )
    }
}

Header.propTypes = {
    menu : PropTypes.array
    ,active : PropTypes.number
};

export default Header;


// WEBPACK FOOTER //
// ./src/component/header.js